import styled from 'styled-components';

//miranda tokens
import { getToken } from '@loadsmart/miranda-tokens';

//theme
import { homeColor, gradBrand } from '@/theme/ai';

//components
import { Section } from '@/containers-ai/SectionHeading';

const GRADIENT_TEXT = `
  background: linear-gradient(45.01deg, #00d7d7 23.29%, #84f11e 88.12%);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
`;

export const AutomateSection = styled(Section)`
  padding: 72px 0;
  background: ${homeColor.bg};

  @media (min-width: 861px) {
    padding: 96px 0;
  }
`;

export const Head = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 40px;
  align-items: end;

  @media (min-width: 861px) {
    grid-template-columns: 1.3fr 0.7fr;
  }
`;

export const Proof = styled.div`
  text-align: left;

  @media (min-width: 861px) {
    text-align: right;
  }
`;

export const ProofValue = styled.b`
  display: block;
  width: fit-content;
  font-family: ${getToken('font-family-title')};
  font-size: 56px;
  font-weight: 800;
  letter-spacing: -0.03em;
  line-height: 1;
  ${GRADIENT_TEXT}

  @media (min-width: 861px) {
    margin-left: auto;
  }
`;

export const ProofText = styled.span`
  font-family: ${getToken('font-family-default')};
  font-size: 14px;
  color: ${homeColor.muted};
`;

// One lifecycle stage: its label on the left (sticky on wide screens), its
// agents as rows on the right. The target of the links in The lineup.
export const Group = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 20px;
  margin-top: 72px;
  scroll-margin-top: 24px;

  @media (min-width: 861px) {
    grid-template-columns: 200px 1fr;
    gap: 32px;
  }
`;

export const GroupLabel = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;

  @media (min-width: 861px) {
    position: sticky;
    top: 24px;
    align-self: start;
  }

  i {
    flex: none;
    width: 14px;
    height: 14px;
    border-radius: 50%;
    background: ${gradBrand};
    box-shadow: 0 0 12px ${homeColor.cyan};
  }

  h3 {
    margin: 0;
    font-family: ${getToken('font-family-default')};
    font-size: 14px;
    font-weight: 700;
    letter-spacing: 0.14em;
    text-transform: uppercase;
    color: ${homeColor.cyan};
  }
`;

export const Row = styled.article`
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 10px;
  align-items: center;
  padding: 24px 0;
  border-top: 1px solid ${homeColor.lineCool};
  scroll-margin-top: 24px;
  transition: background 0.4s;

  &:first-child {
    border-top: 0;
    padding-top: 0;
  }

  /* Landing here from The lineup flashes the row. */
  &:target {
    background: linear-gradient(90deg, rgba(0, 215, 215, 0.08), transparent);
  }

  @media (min-width: 861px) {
    grid-template-columns: 150px 1fr auto;
    gap: 28px;
  }
`;

export const RowStat = styled.div``;

export const RowStatValue = styled.b`
  display: block;
  width: fit-content;
  font-family: ${getToken('font-family-title')};
  font-size: 30px;
  font-weight: 800;
  letter-spacing: -0.02em;
  line-height: 1;
  ${GRADIENT_TEXT}
`;

export const RowStatLabel = styled.span`
  display: block;
  margin-top: 6px;
  font-family: ${getToken('font-family-default')};
  font-size: 12px;
  line-height: 1.3;
  color: ${homeColor.muted};
`;

export const RowTitle = styled.h4`
  margin: 0 0 6px;
  font-family: ${getToken('font-family-title')};
  font-size: 19px;
  font-weight: 700;
  color: ${homeColor.white};
`;

export const RowText = styled.p`
  max-width: 520px;
  margin: 0;
  font-family: ${getToken('font-family-default')};
  font-size: 15px;
  line-height: 1.45;
  color: ${homeColor.muted};
`;

export const ReadMore = styled.a`
  font-family: ${getToken('font-family-default')};
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0.06em;
  white-space: nowrap;
  color: ${homeColor.cyan};

  &:focus-visible {
    outline: 2px solid ${homeColor.cyan};
    outline-offset: 3px;
    border-radius: 8px;
  }
`;

export const CustomBand = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  margin-top: 80px;
  padding: 26px;
  border: 1px solid ${homeColor.line2};
  border-radius: 22px;
  background: radial-gradient(
    120% 200% at 0% 0%,
    ${homeColor.surface},
    ${homeColor.bg2} 60%
  );
  scroll-margin-top: 24px;

  @media (min-width: 861px) {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 34px 38px;
  }
`;

export const CustomTitle = styled.h3`
  margin: 0;
  font-family: ${getToken('font-family-title')};
  font-size: 24px;
  font-weight: 700;
  color: ${homeColor.white};
`;

export const CustomCopy = styled.p`
  margin: 6px 0 0;
  font-family: ${getToken('font-family-default')};
  font-size: 15px;
  color: ${homeColor.muted};
`;
